import angular from "angular";

/**
 * 用于本地测试的配置，修改后不要签入此文件
 */
var localConfig = {
    defaultBuilderLanguage: 'en',
    defaultBuilderRegion: ''
}

let module_name="appConfig";

angular.module('appConfig', []).value('localConfig', localConfig);

export { module_name }